import { useEffect, useState } from "react";
import api from "@/lib/api";

// Iter 115: le funzioni IA sono disponibili solo per il proprietario o per il piano Pro + IA (con tetto mensile)
export function useAiStatus() {
  const [st, setSt] = useState({ enabled: false, loaded: false, reason: "", limit: null, used: 0 });
  useEffect(() => {
    api.get("/ai-status").then(({ data }) => setSt({ ...data, loaded: true })).catch(() => setSt((s) => ({ ...s, loaded: true })));
  }, []);
  return st;
}
